<template>
  <Banners>
    <main
      v-if="screenSize == 'desktop'"
      class="container-max mx-auto box-border w-full px-4 pt-8 text-left md:px-10"
    >
      <h1
        class="text-xl text-dark-gray"
        :class="{ 'animate-pulse': loading }"
      >
        Results for "{{ queryValue }}"
        <span
          v-if="!loading"
          class="ml-1 text-xs text-body-color"
        >
          {{ results.length }}
        </span>
      </h1>
      <search-result-table
        :data="results"
        :loading="loading"
      />
    </main>
    <main v-else>
      <div
        class="flex w-full flex-row flex-wrap items-center justify-center p-4"
      >
        <div class="flex-start flex w-full justify-start">
          <h1
            class="ml-2 pb-3 pt-6 text-left text-xl text-dark-gray"
            :class="{ 'animate-pulse': loading }"
          >
            Results for "{{ queryValue }}"
            <span
              v-if="!loading"
              class="ml-1 text-xs text-body-color"
            >
              {{ results.length }}
            </span>
          </h1>
        </div>
        <template v-if="!loading && results?.length > 0">
          <search-result-card
            v-for="(result, index) in results"
            :key="`search-result-card-idx-${index}`"
            :data="result"
            :loading="loading"
          />
        </template>
        <template v-else-if="!loading && results.length == 0">
          <main
            class="mt-3 flex h-48 w-full items-center justify-center rounded-md bg-off-white p-4 text-body-color"
          >
            No results found
          </main>
        </template>
        <template v-else>
          <search-result-card
            v-for="(result, index) in [1, 2, 3, 4, 5]"
            :key="`search-result-card-idx-${index}`"
            :data="result"
            :loading="loading"
          />
        </template>
      </div>
    </main>
    <section
      v-if="!loading"
      class="flex items-center justify-center py-3"
    >
      <Pagination
        v-if="results?.length > 0"
        :selected-page="pagination.currentPage"
        :total-pages="pagination.totalPages"
        :pages-around="10"
        equivalent
        @select-page="onSelectPage"
      />
    </section>
  </Banners>
</template>
<script setup>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import Banners from '@/components/Banners.vue';
import Pagination from '@/components/Pagination.vue';
import SearchResultTable from '@/components/SearchResults/SearchResultTable.vue';
import SearchResultCard from '@/components/SearchResults/SearchResultCard.vue';

const route = useRoute();
const store = useStore();
const pagination = computed(
  () => store.state.globalSearch.searchResults.pagination
);
const results = computed(() => store.state.globalSearch.searchResults.records);
const queryValue = computed(() => route.query.q);

onMounted(async () => {
  addEventListener('resize', resizeListener);
  loading.value = true;
  await fetchSearch();
  loading.value = false;
});

onBeforeUnmount(() => {
  removeEventListener('resize', resizeListener);
});

watch(queryValue, () => {
  if (!queryValue.value) return;
  fetchSearch(1);
});

const loading = ref(true);

const screenSize = ref(
  window.innerWidth <= 640
    ? 'mobile'
    : window.innerWidth <= 1024
      ? 'tablet'
      : 'desktop'
);

const resizeListener = () => {
  switch (true) {
    case window.innerWidth <= 640:
      screenSize.value = 'mobile';
      break;
    case window.innerWidth <= 1024:
      screenSize.value = 'tablet';
      break;
    default:
      screenSize.value = 'desktop';
  }
};

const onSelectPage = async (page) => {
  loading.value = true;
  await fetchSearch(page);
  loading.value = false;
};

const fetchSearch = async (page) => {
  loading.value = true;
  await store.dispatch('globalSearch/search', {
    searchText: queryValue.value,
    page: page || pagination.value.currentPage,
  });
  loading.value = false;
};
</script>
